/* eslint-disable @typescript-eslint/no-magic-numbers */
import $ from 'jquery';

import _ from '@luna/lodash';
import { getFeatureConfig } from '@luna/feature-config';
import { t } from '@luna/i18n';
import { getSizeHelper, updateSize } from '@retail/core';
import { getUserConfiguration } from '@retail/user-settings-utils';
import {
    getMinWeekDayName,
    getMonthName,
    getShortMonthName,
    getShortWeekDayName,
    getWeekDayName,
} from '@shared/formatting-utils';
import { triggerGlobalEvent } from '@luna/events';

export const checkRedTransactions = () => {
    if (getUserConfiguration().get('redTransactions')) {
        document.body.classList.add('showRedTransactions');
        return;
    }
    document.body.classList.remove('showRedTransactions');
};
export const addCountryClassToBody = () =>
    document.body.classList.add(
        `country-${getFeatureConfig((config) => config.base.country).toLowerCase()}`,
    );

const handleScroll = () => triggerGlobalEvent('scrolled');
const handleResizeOrOrientationChange = () => {
    updateSize();
    triggerGlobalEvent('resize', getSizeHelper().size);
};

const addGlobalListeners = () => {
    if (!getSizeHelper().isTablet) {
        window.addEventListener('scroll', handleScroll);
    }
    window.addEventListener('resize', _.debounce(handleResizeOrOrientationChange, 250));
    window.addEventListener('orientationchange', _.debounce(handleResizeOrOrientationChange, 250));
};

export const getOptions = () => ({
    closeText: t('app.close'),
    prevText: `<${t('app.back')}`,
    nextText: `${t('app.before')}>`,
    currentText: t('app.today'),
    monthNames: [
        getMonthName(0),
        getMonthName(1),
        getMonthName(2),
        getMonthName(3),
        getMonthName(4),
        getMonthName(5),
        getMonthName(6),
        getMonthName(7),
        getMonthName(8),
        getMonthName(9),
        getMonthName(10),
        getMonthName(11),
    ],
    monthNamesShort: [
        getShortMonthName(0),
        getShortMonthName(1),
        getShortMonthName(2),
        getShortMonthName(3),
        getShortMonthName(4),
        getShortMonthName(5),
        getShortMonthName(6),
        getShortMonthName(7),
        getShortMonthName(8),
        getShortMonthName(9),
        getShortMonthName(10),
        getShortMonthName(11),
    ],
    dayNames: [
        getWeekDayName(6),
        getWeekDayName(0),
        getWeekDayName(1),
        getWeekDayName(2),
        getWeekDayName(3),
        getWeekDayName(4),
        getWeekDayName(5),
    ],
    dayNamesShort: [
        getShortWeekDayName(6),
        getShortWeekDayName(0),
        getShortWeekDayName(1),
        getShortWeekDayName(2),
        getShortWeekDayName(3),
        getShortWeekDayName(4),
        getShortWeekDayName(5),
    ],
    dayNamesMin: [
        getMinWeekDayName(6),
        getMinWeekDayName(0),
        getMinWeekDayName(1),
        getMinWeekDayName(2),
        getMinWeekDayName(3),
        getMinWeekDayName(4),
        getMinWeekDayName(5),
    ],
    weekHeader: 'KW',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: '',
});

const setUpDatePickerOptions = () => {
    const options = getOptions();
    $.datepicker.regional[getFeatureConfig((config) => config.base.defaultLanguage)] = options;
    $.datepicker.setDefaults(options);
};

export const initUI = () => {
    addGlobalListeners();
    checkRedTransactions();
    setUpDatePickerOptions();
    addCountryClassToBody();
};
